import { useProviderSearchStore } from "../store/providerSearchStore";

import ButtonContainer from "./ButtonContainer";
import ProviderFilters from "./ProviderFilters/ProviderFilters";
import ProviderList from "./Table/ProviderList";

export default function ProviderInfoContainer() {
  const { data, loading, selectProvider, setOpenProviderDetail, showMap } =
    useProviderSearchStore();

  const onClickProviderDetails = (provider) => {
    selectProvider(provider);
    setOpenProviderDetail(true);
  };

  return (
    <div
      className={`flex h-full flex-col justify-evenly gap-2 transition-all duration-500 ease-in-out bg-white px-6 py-2`}
      style={{
        width: showMap ? "60%" : "100%",
        borderRadius: 8
      }}
    >
      <ProviderFilters />

       <div className="flex flex-1 overflow-hidden py-2">
        <ProviderList
          data={data}
          loading={loading}
          onClickProviderDetail={onClickProviderDetails}
        />
      </div>

      
      <ButtonContainer />
      
    </div>
  );
}
